import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function EyeOffFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9289 15.75C9.89711 15.75 8.25 14.1029 8.25 12.0711C8.25 14.1422 9.85783 15.75 11.9289 15.75ZM22.6708 12.3354C22.0444 13.5883 21.0483 14.9905 19.7703 16.2348L16.9781 13.4426C17.1088 12.9842 17.1788 12.5003 17.1788 12C17.1788 9.1005 14.8283 6.75 11.9288 6.75C11.4285 6.75 10.9445 6.81998 10.4862 6.95069L8.47686 4.94138C9.57069 4.50885 10.7524 4.25 12 4.25C14.5626 4.25 16.8476 5.3422 18.6632 6.78834C20.4774 8.23329 21.8735 10.0699 22.6708 11.6646C22.7764 11.8757 22.7764 12.1243 22.6708 12.3354ZM11.7882 8.2527L15.6763 12.1408C15.678 12.0941 15.6789 12.0471 15.6789 12C15.6789 9.92893 14 8.25 11.9289 8.25C11.8817 8.25 11.8348 8.25091 11.7882 8.2527Z"
				fill="currentColor"
			/>
			<path
				d="M11.9289 15.75C9.89711 15.75 8.25 14.1029 8.25 12.0711C8.25 14.1422 9.85783 15.75 11.9289 15.75ZM11.7882 8.2527L15.6763 12.1408C15.678 12.0941 15.6789 12.0471 15.6789 12C15.6789 9.92893 14 8.25 11.9289 8.25C11.8817 8.25 11.8348 8.25091 11.7882 8.2527Z"
				fill="currentColor"
			/>
			<path
				d="M11.9289 15.75C9.89711 15.75 8.25 14.1029 8.25 12.0711C8.25 14.1422 9.85783 15.75 11.9289 15.75ZM15.6789 12C15.6789 12.0471 15.678 12.0941 15.6763 12.1408L11.7882 8.2527C11.8348 8.25091 11.8817 8.25 11.9289 8.25C14 8.25 15.6789 9.92893 15.6789 12Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.29289 2.29289C2.68342 1.90237 3.31658 1.90237 3.70711 2.29289L9.03382 7.61961L10.1423 8.72808L15.2176 13.8034L16.3092 14.895L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L16.9561 18.3703C15.4885 19.2029 13.8138 19.75 12 19.75C9.43736 19.75 7.15245 18.6578 5.33678 17.2117C3.52261 15.7667 2.1265 13.9301 1.32918 12.3354C1.22361 12.1243 1.22361 11.8757 1.32918 11.6646C2.1265 10.0699 3.52261 8.23329 5.33678 6.78834L5.35759 6.7718L2.29289 3.70711C1.90237 3.31658 1.90237 2.68342 2.29289 2.29289ZM8.25 12.0711C8.25 14.1029 9.89711 15.75 11.9289 15.75C12.6198 15.75 13.2671 15.5631 13.823 15.2372L14.9087 16.3229C14.0622 16.9076 13.0355 17.25 11.9288 17.25C9.02928 17.25 6.67877 14.8995 6.67877 12C6.67877 10.8933 7.02119 9.86663 7.60586 9.02007L8.69168 10.1059C8.36162 10.6575 8.25 11.3817 8.25 12.0711Z"
				fill="currentColor"
			/>
		</svg>
	);
}

EyeOffFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default EyeOffFilledIcon;
